import React from "react";
import { Link } from "react-router-dom";
import {
  HiCheckCircle,
  HiChevronRight,
  HiOutlineSparkles,
} from "react-icons/hi";
import { FaCoins } from "react-icons/fa";

function OrderSuccess() {
  return (
    <div className="min-h-screen bg-[#0b0e14] flex items-center justify-center p-4 selection:bg-cyan-500/30 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none animate-pulse" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-purple-500/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-xl w-full text-center relative z-10">
        <div className="relative inline-block mb-12">
          <div className="absolute inset-0 bg-green-500/20 blur-3xl rounded-full" />
          <HiCheckCircle className="text-9xl text-green-500 relative z-10 animate-scaleIn" />
        </div>

        <div className="space-y-4 mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-green-500/10 border border-green-500/20 rounded-full text-[10px] font-black text-green-400 uppercase tracking-widest italic">
            Deployment_Verified_Secure
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-white uppercase italic tracking-tighter">
            Order <span className="text-cyan-400">Synchronized</span>
          </h1>
          <p className="text-gray-500 font-bold uppercase tracking-[0.2em] text-xs max-w-sm mx-auto leading-relaxed">
            Acquisition sequence complete. Hardware modules are being prepared
            for tactical dispatch.
          </p>
        </div>

        {/* Credits Promo - Booster Pack Style */}
        <div className="bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[2.5rem] p-8 mb-10 relative overflow-hidden group">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500/0 via-amber-500 to-amber-500/0" />

          <div className="flex items-center justify-center gap-6 mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-2xl flex items-center justify-center text-white text-2xl shadow-2xl shadow-amber-500/20 rotate-3 group-hover:rotate-0 transition-transform">
              <FaCoins />
            </div>
            <div className="text-left">
              <p className="font-black text-white uppercase italic tracking-tighter text-xl">
                Loot Booster Available
              </p>
              <p className="text-[10px] font-black text-amber-500 uppercase tracking-widest mt-1">
                Load 30% Bonus Achievement Pts
              </p>
            </div>
          </div>

          <Link
            to="/credits"
            className="flex items-center justify-center gap-3 w-full bg-white text-black py-4 rounded-2xl font-black uppercase tracking-[0.2em] italic text-[10px] hover:invert transition-all duration-300 shadow-xl shadow-amber-500/10"
          >
            <HiOutlineSparkles className="text-lg" /> ACQUIRE_BOOSTER_PACK
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Link
            to="/my-orders"
            className="flex items-center justify-center gap-3 bg-white/5 hover:bg-white/10 border border-white/10 text-white py-4 rounded-2xl font-black uppercase tracking-[0.2em] italic text-[10px] transition-all"
          >
            TRACK_DEPLOYMENT
          </Link>
          <Link
            to="/catalog"
            className="flex items-center justify-center gap-3 bg-cyan-500 text-black hover:bg-cyan-400 py-4 rounded-2xl font-black uppercase tracking-[0.2em] italic text-[10px] transition-all shadow-xl shadow-cyan-500/20"
          >
            RETURN_TO_ARSENAL <HiChevronRight className="text-lg" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OrderSuccess;
